export default __webpack_public_path__ + "static/media/tele.fef975e4.png";